export function getNextHighlightedIndex(
	direction: 'ArrowDown' | 'ArrowUp',
	highlightedIndex: number,
	optionCount: number,
): number {
	if (direction === 'ArrowDown') {
		const index = highlightedIndex === -1 ? 0 : highlightedIndex + 1;
		return index % optionCount;
	}

	const index = (highlightedIndex === -1 ? optionCount - 1 : highlightedIndex - 1) + optionCount;
	return index % optionCount;
}
